export default "__VITE_ASSET__B$bOuGtN__"